import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "badge"]

  connect() {
    // Close on outside click
    this.outsideClickHandler = (event) => {
      if (!this.element.contains(event.target) && this.isOpen()) {
        this.close()
      }
    }
    document.addEventListener("click", this.outsideClickHandler)

    // Close on Escape
    this.escapeHandler = (event) => {
      if (event.key === "Escape" && this.isOpen()) {
        this.close()
      }
    }
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
    document.removeEventListener("keydown", this.escapeHandler)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden", "opacity-0", "scale-95")
    this.panelTarget.classList.add("opacity-100", "scale-100")
  }

  close() {
    this.panelTarget.classList.add("hidden", "opacity-0", "scale-95")
    this.panelTarget.classList.remove("opacity-100", "scale-100")
  }

  isOpen() {
    return !this.panelTarget.classList.contains("hidden")
  }
}
